<template>
  <div class="d-flex">
    <div class="d-flex flex-row flex-grow-1 p-2">
      <div class="d-flex flex-column justify-center">
        <slot name="icon">
          
        </slot>
      </div>
      <div class="d-flex p-3 pl-0 flex-column flex-grow-1">
        <div class="d-flex flex-row">
          <div class="card-panel-title flex-grow-1">
            <div class="row">
              <div class="col">
                <b>{{ title }}</b>
              </div>
              <div class="col">
                  <span class="float-right" data-toggle="tooltip" :title="helptext" data-placement="top">
                      <i class="fa fa-question-circle"></i>
                  </span>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex flex-row flex-grow-1 justify-center">
          <div class="card-panel-body flex-grow-1">
            <slot></slot>
          </div>
        </div>
        <div class="d-flex flex-row">
          <div class="card-panel-footer flex-grow-1">
            <slot name="footer">
              
            </slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['title', 'helptext'],
  mounted() {
    console.log('Component mounted.')
  }
}
</script>
